import { Api } from "../Config/request";

const getEntities = async () => {
  try {
    console.log("Making API request to /entities"); // Debug request
    const response = await Api.GetRequest("/entities");
    console.log("API Response from getEntities:", response); // Debug response
    return response;
  } catch (error) {
    console.error("Error fetching entities:", error);
    throw error;
  }
};

const entityApi = { getEntities };

export default entityApi;